/* LTCG sticky cart CTA (mobile): cart page, drawer and card-shop wall bar. Config: window.__ltcgCctaCfg from snippets/ltcg-cart-cta.liquid. C5 29 Oct. */
(function () {
  if (window.__ltcgCcta) return;
  window.__ltcgCcta = true;
  var C = window.__ltcgCctaCfg || {};
    var mq = window.matchMedia('(max-width: 749px)');
  var isCartPage = !!C.isCartPage;
  var isWall = !!C.isWall;
  var WALL = C.WALL || {};
    var wallCart = null;
    function money(c) {
      var v = (c / 100).toFixed(2), p = v.split('.'), i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'), dec = i + ',' + p[1];
      return WALL.fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dec).replace(/\{\{\s*amount\s*\}\}/, (c / 100).toFixed(2)).replace(/\{\{\s*amount_no_decimals[a-z_]*\s*\}\}/, Math.round(c / 100));
    }
    function loadWall() {
      if (!isWall) return;
      fetch(WALL.root.replace(/\/$/, '') + '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(function (c) { wallCart = c; renderWall(); }).catch(function () {});
    }
    function renderWall() {
      var s = state.wall || (state.wall = {});
      if (!s.bar) {
        s.bar = document.createElement('div');
        s.bar.className = 'ltcg-ccta ltcg-ccta--wall';
        s.bar.innerHTML = '<button type="button" class="ltcg-ccta__info ltcg-ccta__tot"><strong class="ltcg-ccta__val"></strong></button><a class="button ltcg-ccta__btn" href="' + WALL.root.replace(/\/$/, '') + '/checkout"></a>';
        s.bar.querySelector('.ltcg-ccta__info').addEventListener('click', function () { var b = document.querySelector('button[aria-controls="cart-drawer"]'); if (b) b.click(); });
        document.body.appendChild(s.bar);
      }
      var c = wallCart, n = c ? c.item_count : 0;
      var drawerOpen = !!document.querySelector('#cart-drawer dialog[open]');
      var on = mq.matches && n > 0 && !drawerOpen;
      if (n > 0) {
        var allCards = c.items.every(function (i) { return /single|einzelkarte|unit\u00e9/i.test(i.product_type || ''); });
        var w = allCards ? WALL.cards : WALL.items;
        setText(s.bar.querySelector('.ltcg-ccta__val'), '\uD83D\uDED2 ' + n + ' ' + w[n === 1 ? 0 : 1] + ' \u00B7 ' + money(c.total_price));
        setText(s.bar.querySelector('.ltcg-ccta__btn'), WALL.btn);
      }
      s.bar.classList.toggle('is-on', on);
      s.bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (document.body.classList.contains('ltcg-ccta-pad') !== on) document.body.classList.toggle('ltcg-ccta-pad', on);
      if (on) {
        var hV = Math.round(s.bar.getBoundingClientRect().height) + 'px', de = document.documentElement;
        if (de.style.getPropertyValue('--ltcg-ccta-h') !== hV) de.style.setProperty('--ltcg-ccta-h', hV);
      }
    }
    if (isWall && window.fetch && !window.__ltcgCctaFetch) {
      window.__ltcgCctaFetch = true;
      var of = window.fetch;
      window.fetch = function (u) {
        var p = of.apply(this, arguments);
        try {
          var url = typeof u === 'string' ? u : (u && u.url) || '';
          if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(loadWall, 50); }, function () {});
        } catch (e) {}
        return p;
      };
      document.addEventListener('cart:update', function () { setTimeout(loadWall, 50); });
      window.addEventListener('pageshow', loadWall);
    }
    var state = {};

    function ctx(kind) {
      if (kind === 'page') return isCartPage ? document.getElementById('MainContent') : null;
      return document.querySelector('#cart-drawer dialog');
    }

    function setText(el, txt) {
      if (el && el.textContent !== txt) el.textContent = txt;
    }

    function makeBar(kind) {
      var bar = document.createElement('div');
      bar.className = 'ltcg-ccta ltcg-ccta--' + kind;
      bar.setAttribute('data-ltcg-ccta', kind);
      bar.innerHTML =
        '<div class="ltcg-ccta__tot"><span class="ltcg-ccta__lbl"></span><strong class="ltcg-ccta__val"></strong></div>' +
        '<button type="button" class="button ltcg-ccta__btn"></button>';
      bar.querySelector('button').addEventListener('click', function () {
        var s = state[kind];
        if (s && s.real && !s.real.disabled) s.real.click();
      });
      return bar;
    }

    function update(kind) {
      var root = ctx(kind);
      var s = state[kind] || (state[kind] = {});
      if (!root) { if (s.bar) s.bar.classList.remove('is-on'); return; }
      var host = kind === 'page' ? document.body : root;
      if (!s.bar) s.bar = makeBar(kind);
      if (s.bar.parentNode !== host) host.appendChild(s.bar);

      var real = root.querySelector('button[name="checkout"]');
      s.real = real;
      if (real) {
        var label = (real.textContent || '').replace(/\s+/g, ' ').trim();
        var btn = s.bar.querySelector('button');
        setText(btn, label);
        var tot = root.querySelector('[data-testid="cart-total-value"]');
        var totLabel = root.querySelector('.cart-totals__total-label');
        setText(s.bar.querySelector('.ltcg-ccta__val'), tot ? tot.textContent.replace(/\s+/g, ' ').trim() : '');
        setText(s.bar.querySelector('.ltcg-ccta__lbl'), totLabel ? totLabel.textContent.trim() : '');
      }
      render(kind);
    }

    function render(kind) {
      var s = state[kind];
      if (!s || !s.bar) return;
      var root = ctx(kind);
      var drawerOpen = !!document.querySelector('#cart-drawer dialog[open]');
      var below = false;
      if (s.real) {
        var r = s.real.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        below = r.height > 0 && r.top > vh - 10;
      }
      s.below = below;
      // Sticky Fix 29 Oct: no scroll threshold any more; the bar is the always-visible mobile checkout.
      var on =
        (mq.matches || kind === 'drawer') && !!s.real && !s.real.disabled && /* BF 3 Nov: drawer bar at all widths (Pit) */
        (kind === 'drawer' ? drawerOpen : !drawerOpen) &&
        !!root && root.contains(s.real);
      // r2: in the drawer, step aside while the real button is fully visible above where the bar sits (no overlap)
      if (on && kind === 'drawer') {
        var rr = s.real.getBoundingClientRect(), bh = s.bar.offsetHeight || 76, vh2 = window.innerHeight || 0;
        if (rr.height > 0 && rr.top >= 0 && rr.bottom <= vh2 - bh) on = false;
      }
      s.bar.classList.toggle('is-on', on);
      s.bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      s.bar.querySelector('button').tabIndex = on ? 0 : -1;
      // keep clear of the cookie banner (read-only: we only measure it) and reserve room for the bar
      var off = 0;
      var ck = document.getElementById('shopify-pc__banner');
      if (ck) {
        var cr = ck.getBoundingClientRect();
        var cs = getComputedStyle(ck);
        if (cr.height > 0 && cs.display !== 'none' && cs.visibility !== 'hidden') off = Math.max(0, Math.round((window.innerHeight || 0) - cr.top));
      }
      var de = document.documentElement;
      var offV = off + 'px';
      if (de.style.getPropertyValue('--ltcg-ccta-off') !== offV) de.style.setProperty('--ltcg-ccta-off', offV);
      if (on) {
        var hV = Math.round(s.bar.getBoundingClientRect().height) + 'px';
        if (de.style.getPropertyValue('--ltcg-ccta-h') !== hV) de.style.setProperty('--ltcg-ccta-h', hV);
      }
      var padEl = (kind === 'page' && isWall) ? null : kind === 'page' ? document.body : (root && root.querySelector('.cart-drawer__inner'));
      if (padEl && padEl.classList.contains('ltcg-ccta-pad') !== on) padEl.classList.toggle('ltcg-ccta-pad', on);
    }

    var queued = false;
    function refresh() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        update('page');
        update('drawer');
        if (isWall) renderWall();
      });
    }

    function init() {
      refresh();
      loadWall();
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var t = list[i].target;
          if (t.closest && t.closest('.ltcg-ccta')) continue;
          refresh();
          return;
        }
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'disabled', 'hidden', 'style', 'class'] });
      // cookie banner closes: re-measure (we never touch the banner)
      document.addEventListener('visitorConsentCollected', refresh);
      document.addEventListener('click', function () { setTimeout(refresh, 400); }, true);
      if (mq.addEventListener) mq.addEventListener('change', refresh);
      window.addEventListener('resize', refresh, { passive: true });
      // capture: also catches scrolling inside the drawer's own scroll container
      document.addEventListener('scroll', function () { render('page'); render('drawer'); }, { passive: true, capture: true });
      // the drawer slides in: re-check once its animation has finished
      document.addEventListener('transitionend', refresh, true);
      document.addEventListener('animationend', refresh, true);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
